import { render, staticRenderFns } from "./wipcostsoapprovetime.vue?vue&type=template&id=5fa2fdf2&scoped=true&"
import script from "./wipcostsoapprovetime.vue?vue&type=script&lang=js&"
export * from "./wipcostsoapprovetime.vue?vue&type=script&lang=js&"
import style0 from "./wipcostsoapprovetime.vue?vue&type=style&index=0&id=5fa2fdf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2fdf2",
  null
  
)

export default component.exports